import {Component, OnInit} from '@angular/core';
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {VerbrauchsanalyseStepVerbrauchsdatenComponent} from "../../verbrauchsanalyse/verbrauchsanalyse.step.verbrauchsdaten.component";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {VerbrauchsanalyseHeizcheckForm} from "./verbrauchsanalyse.heizcheck.form";
import {EnergyMapService} from '../../energy-map/services/energy.map.service';

/**
 * Custom step for the input of invoices on the step "verbrauchsdaten"
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-verbrauchsanalyse-heizcheck-verbrauchsdaten',
    templateUrl: '../../verbrauchsanalyse/verbrauchsanalyse.step.verbrauchsdaten.component.html',
    standalone: false
})
export class VerbrauchsanalyseHeizcheckStepVerbrauchsdatenComponent extends VerbrauchsanalyseStepVerbrauchsdatenComponent implements OnInit{
  /**
   * (input) data of the user
   */
  anfrage: HeizcheckAnfrage;

  /**
   * @inheritDoc
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param energyMapService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: HeizcheckRequestService, protected elementService: ElementService,
              protected portalService: PortalService, protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in these steps and init the parent form
    this.formConfig = new VerbrauchsanalyseHeizcheckForm(this.energyMapService);

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    super.ngOnInit();

    // preset data
    this.formConfig.setData(this.anfrage.verbrauchsanalyseInput);

    // init the invoices
    this.initInvoices();

    // url for the first step
    this.entryUrl = this.portalService.currentPortalId + '/heizcheck';

    this.textkeyPrefix = 'heizcheck';

    // update the previous step
    this.onStepUpdate();
  }

  /**
   * moveon to the next step in the routing
   */
  moveToNextStep(): void {
    if (this.energyMapService.showEnergyMap(this.anfrage, 'heizcheck') === true
        && this.energyMapService.isEnergyMapDataDonated(this.anfrage) === false
        && this.energyMapService.getEnergyMapConfirmDonation(this.anfrage) !== 'n'
        && this.energyMapService.getEnergyMapBuildingNotIncludedInMap(this.anfrage) !== true
    ) {
      this.router.navigateByUrl(this.portalService.currentPortalId + '/heizcheck/verbrauchsanalyse/energy-map');
    }
    else {
      this.router.navigateByUrl(this.portalService.currentPortalId + '/heizcheck/ergebnis/verbrauchsanalyse');
    }
  }
}
